const BUSINESS_KEYS = {
  CAR01: 'sp-spare-parts-business',
  CAR02: 'sp-garages-business',
  CAR03: 'sp-car-dealers-business',
  CAR04: 'sp-rent-car-business',
  CAR06: 'sp-car-wash-business',
  CAR07: 'sp-car-insurance-business',
  CAR08: 'sp-driving-school-business',
  CAR09: 'sp-car-protection-business',
  CAR10: 'sp-car-towing',
  CAR11: 'sp-taxi-business',
  CAR12: 'sp-air-conditioning-business',
  CAR13: 'sp-quick-services-business',
  CAR14: 'carAgentId',
};

export const getSettingsSidebarOptions = (t, getMybusiness) => {
  // These are PERSONAL account pages — available to every logged-in user
  // (regular users included), so they must never be gated behind "create your
  // business first". noGate: true tells the shared Sidebar not to lock them.
  const options = [
    { link: '/settings-edit-profile', label: t('Edit Profile'), noGate: true },
  ];

  options.push(
    { link: '/settings-saved-items', label: t('Saved Items'), noGate: true },
    {
      link: '/settings-recently-viewed-cars',
      label: t('Recently Viewed Cars'),
      noGate: true,
    },
    { link: '/settings-my-posts', label: t('My Posts'), noGate: true },
  );

  if (getMybusiness?.businessId) {
    const businessRoute = BUSINESS_KEYS[getMybusiness?.businessCode] || 'sp-dashboard';
    options.push({
      link: `/${businessRoute}`,
      label: t('Manage Business'),
      noGate: true,
    });
    // Grouped immediately after "Manage Business" per client request.
    options.push({
      link: '/settings-package',
      label: t('Manage Subscription'),
      noGate: true,
    });
  } else {
    options.push({
      link: '/settings-become-a-seller',
      label: t('Become a Seller'),
      noGate: true,
    });
  }

  options.push({ link: '/', label: t('Logout'), isLogout: true });

  return options;
};
